module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/airbnb-638045f03af53b8b8f1888427fb98956.png";